import { ActionTile } from '@dreamstack/feature-components'
import { useTranslation } from '@dreamstack/i18n'
import { DocumentDownload } from '@dreamstack/icons'
import type {
  FullDownloadableFileFragment,
  LatestDownloadFragment,
} from '@dreamstack/investors-graphql'
import first from 'lodash/first'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import { useFormattedFile } from '..'
import type { QueryAllBlocksRecursivelyResult } from '../contentful/QueryAllBlocksRecursivelyResult'

export const LatestDownload: FunctionComponent<React.PropsWithChildren<{
  block: QueryAllBlocksRecursivelyResult<LatestDownloadFragment>
}>> = ({ block }) => {
  const data = block.customBlockStuff?.latestDownload

  const download = first(data?.latestDownload?.items)
  if (!download) return null
  return <LatestDownloadDisplay download={download} />
}

export const LatestDownloadDisplay: FunctionComponent<React.PropsWithChildren<{
  backgroundImageUrl?: string
  download: FullDownloadableFileFragment
}>> = ({ download, backgroundImageUrl }) => {
  const t = useTranslation()
  const file = download?.file
  const formattedFile = useFormattedFile(file ?? undefined)
  if (!formattedFile) return null
  const { formattedFileSize, formattedFileType } = formattedFile
  return (
    <a href={download?.file?.url ?? '#'} target="_blank" rel="noreferrer">
      <ActionTile
        backgroundImgUrl={backgroundImageUrl}
        heading={
          download?.title ??
          t(`accentro:downloadableFileTypes:${download?.type}`)
        }
        caption={formattedFileType!}
        fileSize={formattedFileSize}
        icon={<DocumentDownload tw="h-px-24 w-px-24" />}
      />
    </a>
  )
}
